import React, { useLayoutEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import LogoDark from '../../assets/imgs/logo2.png'
import LogoLight from '../../assets/imgs/logo_light.svg'
import "./auth.css"
import { useDispatch } from "react-redux";
import { loginAction } from "../../redux/actions/authAction";
import { handlePostRequest } from "../../services/PostTemplate";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const ResetPassword = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const { mobile, fromVerifyOtp } = location?.state || {};
    console.log(mobile)

    const validationSchema = Yup.object().shape({
        confirmPassword: Yup.mixed().required("This field is required."),
        password: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            password: "",
            confirmPassword: "",
        },

        onSubmit: async (data) => {

            console.log(data)

            setSaveBtnLoading(true);
            const payload = {
                mobile: mobile,
                password: data?.password
            }
            console.log(payload)
            try {
                if (data?.password === data?.confirmPassword) {
                    const response = await dispatch(handlePostRequest("api/user/resetpassword", payload, true, true));
                    if (response?.status == 200) {

                        history.push("/")

                    }
                } else {
                    toast.warn("Password and Confirm Password doesn't match")
                }
                setSaveBtnLoading(false);
            }
            catch (error) {
                console.log(error)
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    useLayoutEffect(() => {
        if (!fromVerifyOtp) {
            history.push("./forgot-password")
        }
    }, [fromVerifyOtp])

    return (

        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
                    <div className="login-div-border">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={true ? LogoLight : LogoDark} alt="Image" height="80" className="w-18rem mb-5" />
                                <div className="text-3xl font-medium mb-3" style={{ color: 'whitesmoke' }}>Reset Password</div>
                                {/* <span className="text-600 font-medium">Sign in to continue</span> */}
                            </div>

                            <div className="login-div">
                                <div className="col-12">

                                    <div className="mb-3">
                                        <InputText id='password' type="password" name="password" placeholder="Enter Password" value={formik.values.password} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                        {getFormErrorMessage("password")}
                                    </div>
                                    <div className="mb-3">
                                        <InputText id='confirmPassword' type="password" name="confirmPassword" placeholder="Enter Confirm Password" value={formik.values.confirmPassword} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                        {getFormErrorMessage("confirmPassword")}
                                    </div>
                                </div>
                                <Button label="Reset Password" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl font-medium" />
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </>

    );
};

export default ResetPassword;
